import { render } from "./AddSimilarMaterial.vue?vue&type=template&id=00779162&scoped=true"
import script from "./AddSimilarMaterial.vue?vue&type=script&lang=js"
export * from "./AddSimilarMaterial.vue?vue&type=script&lang=js"

import "./AddSimilarMaterial.vue?vue&type=style&index=0&id=00779162&scoped=true&lang=less"
import "./AddSimilarMaterial.vue?vue&type=style&index=1&id=00779162&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00779162"]])

export default __exports__